<script>
import Layout from "../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import ApiClass from "../api/api";
import Swal from "sweetalert2";

/**
 * Lending component
 */
export default {
  page: {
    title: "Withdraw Token Request List",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Withdraw Token Request List",
      keyChange: null,
      modalId: null,
      dataItems: [],

      items: [
        {
          text: "Withdraw Token Request",
          href: "/admin",
        },
        {
          text: "Withdraw Token Request List",
          active: true,
        },
      ],
      loading: true,
      statusValue: null,
      fields: [
        {
          key: "id",
          value: "id",
        },
        {
          key: "name",
          value: "name",
        },
        {
          key: "mobile",
          value: "mobile",
        },
        {
          key: "token_name",
          value: "token_name",
        },
        {
          key: "token_symbol",
          value: "token_symbol",
        },
        {
          key: "token_address",
          value: "token_address",
        },
        {
          key: "amount",
          value: "amount",
        },

        {
          key: "status",
          value: "status",
        },

        {
          key: "token_action",
          value: "token_action",
        },
      ],
      form: {
        id: null,
        status: null,
        symbol: null,
        currency: null,
        pair_with: null,
      },
    };
  },
  mounted() {
    this.myProvider();
  },
  methods: {
    async myProvider() {
      var res = await ApiClass.getRequest(
        "admin/withdraw_request/getAdmin",
        true
      );

      console.log("token========", res);
      if (res.data.status_code == 1) {
        this.loading = false;
        this.dataItems = res.data.data;
      } else {
        this.loading = false;
      }
    },
    showSwal(data = null) {
      // console.log(this.statusValue);
      this.form.id = data.id;
      this.form.currency = data.currency;
      this.form.pair_with = data.pair_with;
      this.form.status = document.getElementById(data.id).value;
      this.form.symbol = data.symbol;
      this.$swal({
        title: "Please Confirm.",
        text: "Do you want to " + this.form.status + " status for token.",
        icon: "info",
        iconColor: "#ff0000",
        showCancelButton: true,
        cancelButtonColor: "#ff0000",
        cancelButtonText: "No",
        confirmButtonColor: "#008000",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          this.apiHit();
        }
      });
    },
    changeColor(status = null) {
      if (status == "approved") {
        return "color:green";
      } else if (status == "cancel") {
        return "color:red";
      } else {
        return "color:orange";
      }
    },
    async apiHit() {
      let result = await ApiClass.postRequest(
        "admin/withdraw_request/setStatus",
        true,
        this.form
      );
      console.log(result);
      if (result.data.status_code == 1) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: result.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.myProvider();
        this.keyChange = this.keyChange + 1;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: result.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Withdraw Token Request List</h4>

            <div v-if="!loading">
              <b-table
                striped
                hover
                :items="dataItems"
                :fields="fields"
                :busy="loading"
                ref="table"
                show-empty
                sortable="false"
                :key="keyChange"
              >
                <template #empty>
                  <div class="d-flex justify-content-center mb-3">
                    No Record Found
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <!-- <strong>Loading...</strong> -->
                  </div>
                </template>

                <!-- A virtual column -->

                <template v-slot:cell(name)="data">
                  <div v-if="data.item.user">
                    {{ data.item.user.name }}
                  </div>
                </template>
                <template v-slot:cell(mobile)="data">
                  <div v-if="data.item.token">
                    {{ data.item.token.mobile }}
                  </div>
                </template>
                <template v-slot:cell(token_name)="data">
                  <div v-if="data.item.token">
                    {{ data.item.token.name }}
                  </div>
                </template>
                <template v-slot:cell(token_symbol)="data">
                  <div v-if="data.item">
                    {{ data.item.symbol }}
                  </div>
                </template>
                <template v-slot:cell(token_address)="data">
                  <div v-if="data.item.token">
                    {{ data.item.token.token_address }}
                  </div>
                </template>
                <template v-slot:cell(status)="data">
                  <div
                    v-if="data.item.token"
                    class="text-capitalize"
                    :style="changeColor(data.item.status)"
                  >
                    {{ data.item.status }}
                  </div>
                </template>

                <template v-slot:cell(token_action)="data">
                  <select
                    :id="data.item.id"
                    class="form-select shadow-none"
                    @change="showSwal(data.item)"
                  >
                    <option value="">Choose One</option>
                    <option value="approved">Approved</option>
                    <option value="cancel">Cancel</option>
                  </select>
                </template>
              </b-table>
              <b-modal
                id="hi"
                title="Token Details"
                centered
                v-if="modalId"
                ok-only
                okTitle="Cancel"
              >
                <p class="mb-2">
                  Instagram :
                  <span class="text-primary">{{ modalId.instagram }}</span>
                </p>
                <p class="mb-2">
                  Facebook :
                  <span class="text-primary">{{ modalId.facebook }}</span>
                </p>
                <p class="mb-2">
                  Official Website :
                  <span class="text-primary">{{
                    modalId.official_website
                  }}</span>
                </p>
                <p class="mb-2">
                  Whitepaper Link :
                  <span class="text-primary">{{
                    modalId.whitepaper_link
                  }}</span>
                </p>
                <p class="mb-2">
                  Youtube :
                  <span class="text-primary">{{ modalId.youtube }}</span>
                </p>
                <p class="mb-2">
                  Official Telegram :
                  <span class="text-primary">{{
                    modalId.official_telegram
                  }}</span>
                </p>
                <p class="mb-2">
                  Telegram For Chat:
                  <span class="text-primary">{{
                    modalId.telegram_for_chat
                  }}</span>
                </p>

                <!-- <template v-slot:modal-footer>
                  <b-button variant="secondary" @click="showModal = false"
                    >Close</b-button
                  >
                </template> -->
              </b-modal>
              <!--Table ended-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>


<style scoped>
.front_image img,
.back_image img {
  width: 150px;
  height: 120px;
}
.succ_btn {
  float: right;
  clear: both;
  margin: 20px 0px;
}
.clr-red {
  color: red;
}
.success {
  color: green;
  font-weight: 600;
  font-size: 14px;
}
</style>